import React, { useState } from "react";
import logoImage from "@assets/logo-perez-scremini.png";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import "./index.css";
import { Link } from "react-router-dom";
import CustomPopup from "@components/CustomPopUp";
import LogoutIcon from "@assets/logout.svg";

const SideBarAdmin = () => {
  const [isLogoutPopupVisible, setIsLogoutPopupVisible] = useState(false);
  const superAdmin = localStorage.getItem("superAdmin");
  const handleLogoutConfirm = () => {
    localStorage.removeItem("authToken");
    window.location.href = "/admin";
  };

  const showLogoutPopup = () => {
    setIsLogoutPopupVisible(true);
  };

  const hideLogoutPopup = () => {
    setIsLogoutPopupVisible(false);
  };

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">
        <div className="sidebar-header">
          <Link to="/admin/home">
            <img src={logoImage} alt="Logo" className="admin-sidebar-logo" />
          </Link>
        </div>
        <ul>
          <li>
            <Link to="/admin/challenge" className="sidebar-link">
              <EmojiEventsOutlinedIcon style={{ marginRight: "8px", color: "#22BB9F" }} />
              Challenge
            </Link>
          </li>
          <li>
            <Link to="/admin/postales-creadas" className="sidebar-link">
              <PaletteOutlinedIcon style={{ marginRight: "8px", color: "#22BB9F" }} />
              Postales Creadas
            </Link>
          </li>
          <li>
            <Link to="/admin/participantes" className="sidebar-link">
              <PeopleAltOutlinedIcon style={{ marginRight: "8px", color: "#22BB9F" }} />
              Participantes
            </Link>
          </li>
          <li>
            <Link to="/admin/sponsors" className="sidebar-link">
              <MonetizationOnOutlinedIcon style={{ marginRight: "8px", color: "#22BB9F" }} />
              Patrocinadores
            </Link>
          </li>
          {superAdmin && <li>
            <Link to="/admin/administradores" className="sidebar-link">
              <AdminPanelSettingsOutlinedIcon style={{ marginRight: "8px", color: "#22BB9F" }} />
              Administrador
            </Link>
          </li>}
          
        </ul>
        <ul className="log-out-position">
          <li onClick={showLogoutPopup} className="sidebar-link" style={{ cursor: "pointer" }}>
            <LogoutOutlinedIcon style={{ marginRight: "8px", color: "#22BB9F" }} />
            Cerrar Sesión
          </li>
        </ul>
      </nav>
      {isLogoutPopupVisible && (
        <CustomPopup
          icon={LogoutIcon}
          title="¿Seguro que deseas cerrar sesión?"
          message="Estás a punto de cerrar tu sesión. Se perderán todos los cambios que no guardados."
          onClose={hideLogoutPopup}
          onConfirm={handleLogoutConfirm}
          confirmText="Cerrar sesión"
          cancelText="Cancelar"
          type="confirm"
        />
      )}
    </div>
  );
};

export default SideBarAdmin;
